"use client";

import { c as _c } from "react/compiler-runtime";
import { useSite } from "@/contexts/site/site.context";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
import { GemiusTracker } from "@/vendors/Gemius/GemiusTracker";
export function InitializeGemius() {
  const $ = _c(2);
  const {
    gemiusId
  } = useSite();
  const consent = useCookiebotConsent();
  if (!gemiusId || !consent) {
    return null;
  }
  let t0;
  if ($[0] !== gemiusId) {
    t0 = <GemiusTracker gemiusId={gemiusId} />;
    $[0] = gemiusId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}